import { useTranslation } from 'react-i18next';
import { getDateFnsLocale } from '@/lib/dateLocale';
import type { SupportedLanguage } from '@/i18n';

/**
 * Returns the date-fns locale for the current i18n language.
 * Use for format(), formatDistanceToNow(), and Calendar locale prop.
 */
export function useDateLocale() {
  const { i18n } = useTranslation();
  return getDateFnsLocale(i18n.language as SupportedLanguage);
}
